"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
const react_if_1 = require("react-if");
// interface IState {}
exports.NewVersionInner = ({ formikProps, template }) => {
    const queryResult = react_hooks_1.useQuery(graphql_1.emailTemplateWithSuggestedNextVersion, {
        variables: {
            id: template.id,
        },
    });
    const handleEventHtml = (e) => {
        formikProps.setFieldValue('html', e.detail);
    };
    react_1.useEffect(() => {
        window.addEventListener('addEmailTemplateVersionHtml', handleEventHtml);
        return () => {
            window.removeEventListener('addEmailTemplateVersionHtml', handleEventHtml);
        };
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.SmallCenteredLayout, null,
            react_1.default.createElement("div", { className: "lead text-center my-3" },
                react_1.default.createElement("p", { className: "lead mb-2 " },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTag }))),
            react_1.default.createElement(reusables_1.FormGroup, { label: "Version", name: "version" }),
            react_1.default.createElement(react_if_1.If, { condition: !!(queryResult.loading ||
                    queryResult.error ||
                    !(queryResult.data &&
                        queryResult.data.emailTemplate &&
                        queryResult.data.emailTemplate.suggestedNextVersion)) },
                react_1.default.createElement(react_if_1.Then, null,
                    react_1.default.createElement("span", null)),
                react_1.default.createElement(react_if_1.Else, null, () => {
                    return (react_1.default.createElement("p", { className: "mb-0" },
                        "Write your own above or",
                        ' ',
                        react_1.default.createElement("a", { href: "#", onClick: e => {
                                if (e.preventDefault) {
                                    e.preventDefault();
                                }
                                formikProps.setFieldValue('version', queryResult.data.emailTemplate.suggestedNextVersion);
                            } },
                            "use suggested next patch version",
                            ' ',
                            queryResult.data.emailTemplate.suggestedNextVersion)));
                })),
            react_1.default.createElement("div", { className: "lead text-center my-3" },
                react_1.default.createElement("p", { className: "lead mb-2 " },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCode }))),
            react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.ButtonGroup, { className: "text-center w-100" },
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", disabled: !template.url, color: "primary", className: classnames_1.default({
                            active: formikProps.values.codePulledFrom === 'templateURL',
                        }), onClick: () => {
                            if (!template.url) {
                                return;
                            }
                            formikProps.setFieldValue('url', template.url);
                            formikProps.setFieldValue('codePulledFrom', 'templateURL');
                        } }, "Default URL"),
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "primary", className: classnames_1.default({
                            active: formikProps.values.codePulledFrom === 'versionURL',
                        }), onClick: () => {
                            if (formikProps.values.codePulledFrom === 'versionURL') {
                                return;
                            }
                            formikProps.setFieldValue('codePulledFrom', 'versionURL');
                        } }, "New URL"),
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "primary", className: classnames_1.default({
                            active: formikProps.values.codePulledFrom === 'pastedHTML',
                        }), onClick: () => {
                            formikProps.setFieldValue('codePulledFrom', 'pastedHTML');
                        } }, "Raw HTML"),
                    react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "primary", className: classnames_1.default({
                            active: formikProps.values.codePulledFrom === 'hostedFileURL',
                        }), onClick: () => {
                            formikProps.setFieldValue('codePulledFrom', 'hostedFileURL');
                        } }, "Upload file"))),
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: formikProps.values.codePulledFrom === 'hostedFileURL' },
                react_1.default.createElement("div", { className: "text-center pt-5 mb-3" },
                    react_1.default.createElement(reusables_1.FileUploader, { ajaxButton: true, icon: pro_solid_svg_icons_1.faFileUpload, loadingText: "Uploading...", label: "Upload file", accept: ".html,.htm,.mjml", size: "lg", color: "link", onUpload: file => {
                            formikProps.setFieldValue('url', file.url);
                        } }))),
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: formikProps.values.codePulledFrom !== 'pastedHTML' },
                react_1.default.createElement("div", { className: "py-3" },
                    react_1.default.createElement(reusables_1.FormGroup, { label: "Code URL", name: "url", type: "url", placeholder: "https://example-dev-site.com/email-template.html", disabled: formikProps.values.codePulledFrom !== 'versionURL' }))),
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: formikProps.values.codePulledFrom === 'pastedHTML' },
                react_1.default.createElement(reusables_1.FormGroup, { label: "HTML", name: "html", type: "textarea", placeholder: "<html><head>...</head><body>...</body></html>", rows: 6, disabled: formikProps.values.codePulledFrom !== 'pastedHTML' })),
            react_1.default.createElement(reusables_1.FormGroup, { label: "Release notes", name: "releaseNotes", type: "textarea", placeholder: "I changed _____ because _____", rows: 3 }))));
};
//# sourceMappingURL=NewVersionInner.js.map